import { createSlice } from "@reduxjs/toolkit";

export enum AgendaEventFormSteps {
  AddDetails = "Agenda Event Details",
  UploadMedia = "Add Media",
  AssignViewers = "Departments, Roles, and Employees",
  PublishAgendaEvent = "Publish Agenda Event",
}

export type AgendaEventFormState = {
  step: AgendaEventFormSteps | null;
  selectedAgendaId: string | null;
};

const initialState: AgendaEventFormState = {
  step: null,
  selectedAgendaId: null,
};

const agendaEventFormSlice = createSlice({
  name: "agendaEventForm",
  initialState,
  reducers: {
    resetAgendaEventFormState(state) {
      state.step = AgendaEventFormSteps.AddDetails;
      state.selectedAgendaId = null;
    },
    setAgendaEventFormStep(state, action) {
      state.step = action.payload;
    },
    setSelectedAgendaEventId(state, action) {
      state.selectedAgendaId = action.payload;
    },
  },
});

export const {
  resetAgendaEventFormState,
  setAgendaEventFormStep,
  setSelectedAgendaEventId,
} = agendaEventFormSlice.actions;

export default agendaEventFormSlice.reducer;
